module.exports = __webpack_public_path__ + "static/img/bg15.b9bc35c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg15.png
// module id = 25de
// module chunks = 1